import type { HyperEntityConfig } from "@shared/backend/hyper-entity.decorator";
import { Roles } from "@shared/Roles";
import { remult } from "remult";
import { type CallCenterChatMessage } from "./entity";

export const CallCenterChatMessageEntityConfig: HyperEntityConfig<CallCenterChatMessage> =
  {
    caption: "הודעות צ'אט מוקד",
    allowApiRead: Roles.AdminsAndManager,
    allowApiInsert: false,
    allowApiUpdate: false,
    allowApiDelete: false,
    apiPrefilterPerRole: (filter) => {
      if (!remult.user) return;

      filter(Roles.SuperDuperAdmin, false);
      filter(Roles.SuperAdmin, true);
      filter(Roles.OrganizationManagers, {
        organization: {
          $id: remult.user.organizationId,
        },
      });
      filter(Roles.User, false);
    },
  };
